import Carrier from './src/carrier'

export default Carrier